var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 22.375C18.0228 22.375 22.5 17.8978 22.5 12.375C22.5 6.85215 18.0228 2.375 12.5 2.375C6.97715 2.375 2.5 6.85215 2.5 12.375C2.5 17.8978 6.97715 22.375 12.5 22.375Z",
    stroke: "black",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5078 10.8832C11.6794 10.8832 11.0078 11.5548 11.0078 12.3832C11.0078 13.2116 11.6794 13.8832 12.5078 13.8832C13.3362 13.8832 14.0078 13.2116 14.0078 12.3832C14.0078 11.5548 13.3362 10.8832 12.5078 10.8832ZM12.5078 10.8832V7.37402M15.5147 15.3948L13.5661 13.4462",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.da1af7cdefed610602d401f6126f8d03.svg";
export { ForwardRef as ReactComponent };